<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex w-72 flex-col !p-0">
			<div fxHide></div>
			@if (showReset$ | async) {
			<div class="flex justify-center mt-2">
				<button
					(click)="resetDate()"
					mat-stroked-button
				>
					<mat-icon>today</mat-icon>
					{{ "utils.resetCalendar" | translate }}
				</button>
			</div>
			}
			<mat-calendar
				(_userSelection)="this.selectedChange($event)"
				[maxDate]="max"
				[minDate]="min"
				[selected]="viewDate$ | async"
				[startAt]="(viewDate$ | async)?.start"
				class="-mt-4"
			></mat-calendar>
		</mat-card>
	</div>
</ng-template>
